import { SvgIconProps } from '@mui/material';
import { CreditCard, Extension, Store } from '@mui/icons-material';
import { ComponentType } from 'react';
import { CountryCode } from '../generated/graphql';
import { AdminPermissions } from '../providers/auth.provider';
import {
  CostRadarTrialRoute,
  CustomCheckoutRoute,
  DashboardRoute,
  GracePeriodRoute,
  InvoiceBillingRoute,
  NewAccountRoute,
  PaywallRoute,
  StoryousIntegrationRoute,
  SubscriptionLimitRoute,
  SupplierIntegrationsRoute,
  VenueManagementRoute,
} from '../routes';
import { RouteType } from '../routes/types';

export interface SidebarLink {
  path: string;
  title: string;
  Icon?: ComponentType<SvgIconProps>;
  isNew?: boolean;
  isAccountingTier?: boolean;
  supportedCountries?: CountryCode[];
  permission?: keyof AdminPermissions;
}

export interface SidebarSection {
  title: string;
  Icon?: ComponentType<SvgIconProps>;
  children: SidebarLink[];
}

export type SidebarItem = SidebarLink | SidebarSection;

export const isSidebarSection = (item: SidebarItem): item is SidebarSection =>
  'children' in item;

const linkFromRoute = (
  route: RouteType,
  permission?: keyof AdminPermissions,
): SidebarLink => ({
  path: route.path,
  title: route.title,
  Icon: route.icon,
  permission,
});

export const sidebarStructure: SidebarItem[] = [
  linkFromRoute(DashboardRoute),
  {
    title: 'Venues',
    Icon: Store,
    children: [
      linkFromRoute(NewAccountRoute, 'canCreateNewVenues'),
      linkFromRoute(VenueManagementRoute, 'canManageVenues'),
      linkFromRoute(GracePeriodRoute, 'canModifyPaymentFailureGracePeriod'),
    ],
  },
  {
    title: 'Billing',
    Icon: CreditCard,
    children: [
      linkFromRoute(PaywallRoute, 'canMoveVenueToPaywall'),
      linkFromRoute(SubscriptionLimitRoute, 'canModifyInvoiceLimit'),
      linkFromRoute(CustomCheckoutRoute, 'canCreateCustomCheckout'),
      linkFromRoute(InvoiceBillingRoute, 'canManageInvoiceBilling'),
    ],
  },
  {
    title: 'Integrations',
    Icon: Extension,
    children: [
      linkFromRoute(StoryousIntegrationRoute, 'canConnectStoryousIntegration'),
      linkFromRoute(CostRadarTrialRoute, 'canModifyCostRadarTrial'),
      linkFromRoute(SupplierIntegrationsRoute, 'canManageSupplierIntegrations'),
    ],
  },
];
